import { cssVar } from './cssVar'

export const fontTokens = {
  sans: cssVar('--app-font-sans'),
  display: cssVar('--app-font-display'),
  sizeSm: cssVar('--app-font-size-sm'),
  sizeMd: cssVar('--app-font-size-md'),
}
